export const DEMO_MODE_STORAGE_KEY = 'vb-demo-mode';

export const DEMO_MODE_PREFIXES = {
  DISTRIBUTOR: 'Distributor',
  MARKET: 'Market',
  CLIENT: 'Client',
  CAMPUS: 'Campus',
  MACHINE: 'Machine',
  LABEL: 'Label',
  ACCOUNT: 'Account',
  USER: 'User',
} as const;

/** Strings to leave unchanged when anonymizing chart labels */
export const CHART_LABEL_SKIP_LIST = ['Unknown', 'Total', 'N/A', 'All', ''];

/** Map for anonymizing emails (account, approvers, createdBy) */
export const EMAIL_ANONYMIZED_SUFFIX = '@example.demo';
